import NavSlot from "@/components/navigation/links";
import { Outlet, useMatch } from "react-router-dom";

export default function Responsibilities() {
  // Works for both /profile/responsibilities and /organization/employees/:id/responsibilities
  const employeeMatch = useMatch("/organization/employees/:employeeId/responsibilities/*");
  const BASE = employeeMatch
    ? `/organization/employees/${employeeMatch.params.employeeId}/responsibilities`
    : "/profile/responsibilities";

  const navItems = [
    { label: "PC", path: `${BASE}/project-coordinator` },
    { label: "AM", path: `${BASE}/account-manager` },
    { label: "SC", path: `${BASE}/sales-coordinator` },
    { label: "JC", path: `${BASE}/job-coordinator` },
    { label: "MC", path: `${BASE}/milestone-coordinator` },
    { label: "DH", path: `${BASE}/department-head` },
    { label: "DC", path: `${BASE}/department-coordinator` },
    { label: "Timesheet Reviewer", path: `${BASE}/reviewer` },
    { label: "Timesheet", path: `${BASE}/timesheet` },
    { label: "TL", path: `${BASE}/team-lead` },
  ];

  return (
    <div className="flex-1 overflow-auto relative mt-10">
      <div className="fixed top-12 md:top-16 w-full bg-white z-1">
        <NavSlot navItems={navItems} />
      </div>
      <Outlet />
    </div>
  );
}
